import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import { useMenuData } from "../../lib/hooks";

import css from "./NotFound.module.scss";

/* eslint-disable react/forbid-prop-types */

const SimplifiedMenuChidren = ({ below = [] }) => {
  if (!below.length) {
    return [];
  }
  return (
    <ul>
      {below.map(b => (
        <SimplifiedMenuItem key={b.key} item={b} />
      ))}
    </ul>
  );
};

SimplifiedMenuChidren.propTypes = {
  below: PropTypes.array
};

SimplifiedMenuChidren.defaultProps = {
  below: []
};

const SimplifiedMenuItem = ({ item }) => {
  const { title, relative = "", below = [] } = item;
  if (!relative.length && !below.length) {
    return [];
  }
  return (
    <li>
      {relative.length > 0 && <Link to={relative}>{title}</Link>}
      {relative.length === 0 && title}
      <SimplifiedMenuChidren below={below} />
    </li>
  );
};

SimplifiedMenuItem.propTypes = {
  item: PropTypes.any.isRequired
};

const NotFound = ({ className = "", pathname = "" }) => {
  const menuTree = useMenuData();
  return (
    <div className={[css.notFound, className || ""].join(" ")}>
      <h1>Page not found</h1>
      <p>
        {/* eslint-disable react/jsx-one-expression-per-line */}
        We looked for the content at {pathname} and couldn&apos;t locate it.
        {/* eslint-enable react/jsx-one-expression-per-line */}
        <br />
        Sorry for the inconvenience. Please try the following links to resume
        your journey.
      </p>
      <h2>Gallery Guides and Podcasts menu</h2>
      <SimplifiedMenuChidren below={menuTree} />
      <h2>Other information</h2>
      <ul>
        <li>
          <a href="https://www.sl.nsw.gov.au">State Library of NSW website</a>
        </li>
        <li>
          <a href="https://www.sl.nsw.gov.au/whats-on">What&apos;s on</a>
        </li>
        <li>
          <a href="https://www.sl.nsw.gov.au/plan-your-visit">
            Plan your visit
          </a>
        </li>
        <li>
          <a href="https://www.sl.nsw.gov.au/contact-us">Contact us</a>
        </li>
      </ul>
    </div>
  );
};

NotFound.propTypes = {
  className: PropTypes.string,
  pathname: PropTypes.string
};

NotFound.defaultProps = {
  className: "",
  pathname: ""
};

export default NotFound;
